import { css } from 'styled-components';
import { SHADOW_DEFAULT, SHADOW_FOCUSED } from '../../shadows';
export const buttonBoxShadowMixin = css`
  box-shadow: ${({
  disabled,
  inactive,
  noShadow,
  noShadowDisabled
}) => /* prettier-ignore */
disabled && !inactive ? noShadowDisabled ? 'none' : SHADOW_DEFAULT : noShadow ? 'none' : SHADOW_DEFAULT};

  ${({
  inactive,
  disabled,
  $hasTouch,
  noShadowHover,
  noShadowFocus
}) => !inactive && !disabled && !$hasTouch && css`
      &:hover {
        box-shadow: ${noShadowHover ? 'none' : SHADOW_FOCUSED};
      }
      &:focus {
        box-shadow: ${noShadowFocus ? 'none' : SHADOW_FOCUSED};
      }
    `}
  ${({
  inactive,
  disabled,
  noShadowActive
}) => !inactive && !disabled && css`
      &:active {
        box-shadow: ${noShadowActive ? 'none' : SHADOW_FOCUSED};
      }
    `}
`;
export const buttonBoxShadowKeys = ['noShadow', 'noShadowActive', 'noShadowHover', 'noShadowFocus', 'noShadowDisabled'];